import { applyJob, getAvailableJobs } from "../../api/jobs"

const state = {
  jobs: [],
  currentJob: null,
  jobFormShow: false,
  applying: false,
}
const getters = {
  jobs: state => state.jobs,
  currentJob: state => state.currentJob,
  jobFormShow: state => state.jobFormShow,
  applying: state => state.applying,
}
const mutations = {
  setJobs: (state, jobs) => { state.jobs = jobs },
  setCurrentJob: (state, job) => { state.currentJob = job },
  setJobFormShow: (state, bol) => { state.jobFormShow = bol },
  setApplying: (state, applying) => { state.applying = applying },
}
const actions = {
  async fetchJobs ({ commit }) {
    const jobs = await getAvailableJobs()
    if (jobs) {
      commit("setJobs", jobs)
      commit("setCurrentJob", jobs[0])
    }
  },
  async applyJob ({ commit, state }, form) {
    if (state.applying) return
    commit("setApplying", true)
    const data = await applyJob(form)
    commit("setApplying", false)
    return data
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}



// WEBPACK FOOTER //
// ./src/store/modules/job.js